import { useFoodpilotContext } from "src/context/FoodpilotContext";
import { usePuckCompanyScore } from "src/components/Puck/config/contexts/PuckCompanyScoreContext";
import { useDiagnosticFacts } from "./useDiagnosticFacts";

export const textUsesCalcTokens = (text: string): boolean => text.includes("calc.");

type OrganizationDiagnosticFactsOptions = {
    catalog?: boolean;
};

export const useOrganizationDiagnosticFacts = (
    text: string,
    { catalog = false }: OrganizationDiagnosticFactsOptions = {},
) => {
    const foodpilotContext = useFoodpilotContext();
    const scoreContext = usePuckCompanyScore();
    const usesCalcTokens = textUsesCalcTokens(text);
    const organizationId = foodpilotContext.selectedCompany?.id;
    const campaignId = foodpilotContext.currentCampaign?.id;
    const ssqVersionId = scoreContext.companyPost?.ssqVersionId;

    const enabled =
        (usesCalcTokens || catalog) &&
        typeof organizationId === "number" &&
        typeof campaignId === "number" &&
        typeof ssqVersionId === "number" &&
        !scoreContext.isLoading;

    const query = useDiagnosticFacts({
        enabled,
        campaignId,
        ssqVersionId,
        entityType: "Organization",
        entityId: organizationId,
        organizationId,
        catalog,
    });

    return {
        ...query,
        usesCalcTokens,
    };
};
